{
  "login-secret-with-password-page": {
    "buttons": {
      "forgot-password": "Mot de passe oublié",
      "login": "Connexion",
      "set-password": "Définir le mot de passe",
      "update-password": "Mise à jour du mot de passe"
    },
    "text": {
      "new-password": "Définissez votre mot de passe",
      "new-password-hint": "Votre mot de passe sera nécessaire pour les connexions ultérieures",
      "password": "Mot de passe",
      "password-invalid": "Votre mot de passe est incorrect. Veuillez réessayer !",
      "password-hint": "Veuillez saisir votre mot de passe pour vous connecter",
      "update-password": "Nouveau mot de passe",
      "update-password-hint": "Veuillez saisir votre nouveau mot de passe",
      "your-password": "Votre mot de passe"
    }
  }
}
